<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Lista de Pedidos
        <v-spacer />
        <calendario @onDataSelecionada="onDataSelecionada" />
      </v-card-title>
      <v-data-table
        dense
        :headers="headers"
        :items="listaPedido"
      >
        <template v-slot:item.vlTotal="{ item }">
          {{ formatPrice(item.vlTotal) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                color="blue"
                @click="onPesquisar(item)"
                v-on="on"
              >
                mdi-magnify
              </v-icon>
            </template>
            <span>Itens</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                color="blue"
                @click="onTramitacao(item)"
                v-on="on"
              >
                mdi-progress-helper
              </v-icon>
            </template>
            <span>Tramitação</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialogItem"
      max-width="800"
    >
      <modelItemPedido
        v-if="dialogItem"
        :pedido="pedido.cdOrcamento"
      />
    </v-dialog>
    <v-dialog
      v-model="dialogTramitacao"
      max-width="500"
    >
      <modelTramitacaoOrcamento
        v-if="dialogTramitacao"
        :pedido="pedido.cdOrcamento"
      />
    </v-dialog>
  </v-container>
</template>
<script>
  import pedidoRep from '../../../components/services/orcamentoRepository'
  import transacaoRep from '../../../components/services/transacaoRepository'
  // COMPONENTES
  import modelItemPedido from '../../componentes/modal-listaprodutos-pedido.vue'
  import modelTramitacaoOrcamento from '../../componentes/modal-tramitacaoorcamento.vue'
  import calendario from '../../componentes/util/datacalendario.vue'
  export default {
    components: {
      calendario,
      modelItemPedido,
      modelTramitacaoOrcamento,
    },
    data () {
      return {
        dataAtual: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        headers: [
          {
            text: 'Pedido',
            align: 'start',
            value: 'pedidoFormatado',
            width: 100,
          },
          {
            text: 'Cliente',
            align: 'start',
            value: 'nmCliente',
            width: 200,
          },
          {
            text: 'Vl. Total',
            align: 'end',
            value: 'vlTotal',
            width: 200,
          },
          { text: '', value: 'actions', width: 100, sortable: false },
        ],
        listaPedido: [],
        tramitacaoPedido: [],
        pedido: {},
        dialogItem: false,
        dialogTramitacao: false,
      }
    },
    async created () {
      this.dataSelecionada = this.formatDate(this.dataAtual)
      // this.getTransacao()
      if (this.$store.getters.usuario.tpusuario !== 'A') {
        await this.getTransacao()
      }
      if (this.$store.getters.usuario.cdvendedor === 0) {
        this.$swal({
          icon: 'error',
          text: 'É necessario vendedor para acessar.',
          confirmButtonText: 'OK',
        }).then((result) => {
          if (result.isConfirmed) return false
        })
      } else {
        this.onCarregarConsulta()
      }
    },
    methods: {
      onDataSelecionada (data) {
        this.dataSelecionada = data
        this.onCarregarConsulta()
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      async onCarregarConsulta () {
        this.$store.commit('setSplashScreen', true)
        await pedidoRep.getListDate(this.dataSelecionada, 0, this.$store.getters.vendedor.flGerente === true ? 0 : this.$store.getters.vendedor.cdVendedor).then(response => {
          if (response.data.status === 'sucesso') {
            this.$store.commit('setSplashScreen', false)
            this.listaPedido = response.data.dados
          } else if (response.data.status === 'mensagem') {
            this.$store.commit('setSplashScreen', false)
            this.$swal({
              icon: 'warning',
              text: response.data.dados,
            })
          } else if (response.data.status === 'error') {
            this.$store.commit('setSplashScreen', false)
            this.$swal({
              icon: 'error',
              text: response.data.messagem,
            })
          } else {
            this.$swal({
              icon: 'error',
              text: response.data.mensagemErro,
            })
            this.$store.commit('setSplashScreen', false)
          }
        }).catch(error => {
          this.$store.commit('setSplashScreen', false)
          this.$swal({
            icon: 'error',
            text: error,
          })
        })
      },
      async getTransacao () {
        this.$store.commit('setSplashScreen', true)
        var dados = {
          usuario: this.$store.getters.usuario.cdusuario,
          transacao: 'FA001FOT',
        }
        await transacaoRep.get(dados).then(response => {
          if (response.data.status === 'mensagem') {
            this.$store.commit('setSplashScreen', false)
            this.$swal({
              icon: 'warning',
              text: response.data.dados,
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) this.$router.replace('/v1')
            })
          } else if (response.data.status === 'error') {
            this.$store.commit('setSplashScreen', false)
            this.$swal({
              icon: 'error',
              text: response.data.messagem,
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) this.$router.replace('/v1')
            })
          } else {
            this.$store.commit('setSplashScreen', false)
          }
        }).catch(error => {
          this.$store.commit('setSplashScreen', false)
          // this.$swal({
          //   icon: 'error',
          //   text: error,
          // })
          this.$swal({
            icon: 'error',
            text: error,
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) this.$router.replace('/v1')
          })
        })
      },
      formatPrice (value) {
        var val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      onPesquisar (pedido) {
        this.dialogItem = true
        this.pedido = pedido
      },
      onTramitacao (pedido) {
        this.dialogTramitacao = true
        this.pedido = pedido
      },
      onSairExpedicao () {
        this.dialogExpedicao = false
      },
      onSucessoExpedicao () {
        this.dialogExpedicao = false
      },
    },
  }
</script>
